export class Title {
    constructor(pixiContext, sheets) {
        // to ignore the type error
        this.sprite = null;
        for (const sheet of sheets) {
            if (sheet.hasAnimation(fileName)) {
                this.sprite = sheet.animation(pixiContext, fileName);
            }
        }
        this.sprite.animationSpeed = 0.1;
    }
}
export const fileName = "title";
//# sourceMappingURL=title.js.map